export default class SessionToken {
	token: string = '';
	permissions: Array<string> = [];
	name: string = '';
	lastLogin: any= 0;
	expiresIn: any= 0;
	username: string = '';
	email: string = '';
	key?: string = '';
	oauth?: boolean = false;
	isTeacher?: boolean = false;
}
